import React from 'react';
import {ResponsiveCalendar} from '@nivo/calendar';
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';

interface CalendarGraphProps {
    data: {value: number; day: string}[];
    from: string;
    to: string;
    isLoading: boolean;
}
function CalendarGraph(props: CalendarGraphProps): JSX.Element {
    const {data, from, to, isLoading} = props;

    return (
        <div style={{height: 'calc(16rem)'}}>
            {isLoading ? (
                <Skeleton height="100%" />
            ) : (
                <ResponsiveCalendar
                    data={data}
                    from={from}
                    to={to}
                    emptyColor="#eeeeee"
                    colors={['#61cdbb', '#97e3d5', '#e8c1a0', '#f47560']}
                    margin={{top: 10, right: 20, left: 20}}
                    yearSpacing={40}
                    monthBorderColor="#ffffff"
                    monthBorderWidth={4}
                    dayBorderColor="#ffffff"
                    minValue="auto"
                    legends={[
                        {
                            anchor: 'bottom-right',
                            direction: 'row',
                            translateY: -40,
                            translateX: -40,
                            itemCount: 4,
                            itemWidth: 42,
                            itemHeight: 36,
                            itemsSpacing: 14,
                            itemDirection: 'left-to-right',
                        },
                    ]}
                />
            )}
        </div>
    );
}

export default CalendarGraph;
